<template>
  <div class="lightbar-container">
    <div
      class="lightbar"
      :class="status"
    >
      <div
        id="light-1"
        :class="lights[0]"
      >
        <div class="inner-light" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
      </div>
      <div
        id="light-2"
        :class="lights[1]"
      >
        <div class="inner-light" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
      </div>
      <div
        id="light-3"
        :class="lights[2]"
      >
        <div class="inner-light" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
      </div>
      <div
        id="light-4"
        :class="lights[3]"
      >
        <div class="inner-light" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
      </div>
      <div
        id="light-5"
        :class="lights[4]"
      >
        <div class="inner-light" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
      </div>
      <div
        id="light-6"
        :class="lights[5]"
      >
        <div class="inner-light" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
        <span class="bulb" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    const status = 'default';
    const statusLights = {
      'default': [
        'light strobe blue',
        'light strobe blue',
        'light strobe blue',
        'light strobe red delay',
        'light strobe red delay',
        'light strobe red delay',
      ],

      'default_1': [
        'light strobe blue',
        'light strobe red delay',
        'light strobe blue',
        'light strobe red delay',
        'light strobe blue',
        'light strobe red delay',
      ],

      'spotlight': [
        'light strobe blue',
        'light strobe red delay',
        'light strobe spotlight',
        'light strobe spotlight',
        'light strobe red delay',
        'light strobe blue',
      ],

      'traffic': [
        'light strobe blue',
        'light strobe warn on',
        'light strobe warn on',
        'light strobe warn on',
        'light strobe warn on',
        'light strobe blue delay',
      ],

      'caution': [
        'light caution', 'light caution', 'light caution', 'light caution', 'light caution', 'light caution',
      ],

      'warn left': [
        'light warn left', 'light warn left', 'light warn left', 'light warn left', 'light warn left', 'light warn left',
      ],

      'warn right': [
        'light warn right', 'light warn right', 'light warn right', 'light warn right', 'light warn right', 'light warn right',
      ],

      'off': [
        'light', 'light', 'light', 'light', 'light', 'light',
      ],
    };

    return {
      lights: statusLights[status],
      status,
      statusLights,
    };
  },

  mounted () {
    this.$eventHub.$on('flashing-light', this.show);
  },

  destroyed () {
    this.$eventHub.$off('flashing-light', this.show);
  },

  methods: {
    show (status) {
      if (this.status === status) {
        return;
      }

      this.status = status;
      this.lights = this.statusLights[status];
    },
  },
};
</script>
